// Hybrid allocation & CVM — PSD §6.3 (F6.3). Engine layer (framework-free).
import { fullyDilutedShares } from './fullyDiluted';
import { DLOM_CLAMP_MAX } from './constants';
/**
 * Hybrid method: weighted blend of OPM and PWERM by company stage.
 * Early-stage: higher PWERM weight; later-stage: higher OPM weight.
 */
export function runHybrid(opmEquityValue, pwermEquityValue, stage = 'growth', capTable, _A, dlomPct) {
    const weights = {
        seed: { opm: 0.3, pwerm: 0.7 },
        early: { opm: 0.5, pwerm: 0.5 },
        growth: { opm: 0.7, pwerm: 0.3 },
        late: { opm: 0.9, pwerm: 0.1 },
    };
    const w = weights[stage];
    const weightedV = w.opm * opmEquityValue + w.pwerm * pwermEquityValue;
    const fd = Math.max(1, fullyDilutedShares(capTable));
    const dlom = Math.min(DLOM_CLAMP_MAX, Math.max(0, dlomPct));
    const commonValuePost = weightedV * (1 - dlom);
    const fmv = commonValuePost / fd;
    const headline = {
        totalEquityValue: weightedV,
        commonValuePreDlom: weightedV,
        commonValuePostDlom: commonValuePost,
        fullyDilutedShares: fd,
        commonFmvPerShare: fmv,
        recommendedStrikePrice: Math.ceil(fmv * 100) / 100,
        safeHarborWindowDays: 365,
        preferredPricePerShare: null,
        commonToPreferredDiscount: null,
        perShareByClass: [],
    };
    return {
        weightedEquityValue: weightedV,
        opmWeight: w.opm,
        pwermWeight: w.pwerm,
        headline,
        allocation: [],
    };
}
/**
 * Current Value Method (CVM): allocate pro-rata based on invested capital.
 * Used for very early-stage companies with no meaningful OPM inputs.
 */
export function runCvm(capTable, directEquityValue, dlomPct) {
    const fd = Math.max(1, fullyDilutedShares(capTable));
    const dlom = Math.min(DLOM_CLAMP_MAX, Math.max(0, dlomPct));
    const commonValuePost = directEquityValue * (1 - dlom);
    const fmv = commonValuePost / fd;
    const headline = {
        totalEquityValue: directEquityValue,
        commonValuePreDlom: directEquityValue,
        commonValuePostDlom: commonValuePost,
        fullyDilutedShares: fd,
        commonFmvPerShare: fmv,
        recommendedStrikePrice: Math.ceil(fmv * 100) / 100,
        safeHarborWindowDays: 365,
        preferredPricePerShare: null,
        commonToPreferredDiscount: null,
        perShareByClass: [],
    };
    return { headline, allocation: [] };
}
//# sourceMappingURL=hybrid.js.map